/*
 *
 * ManageStructurePopup
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 29-Jan-2025
 */

import ManageStructurePopup from './ManageStructurePopupContainer'

export default ManageStructurePopup
